import cloneDeep from "lodash/cloneDeep";
import { ConsumerStateWrapper } from "./ConsumerStateWrapper";
import { Logger } from "../Logger";
import { eventsManager, gatherVideoClientDataSource } from "../Globals";
import { ErrorContext } from "gather-common/dist/src/public/utils";
import { MetricsEventName } from "gather-http-common/dist/src/public/metrics/constants";
import { GVCInternalEvent } from "../EventEmitter/GVCEventEmitter";
const ZERO_METRICS = {
    failToConnectCount: 0,
    totalConversationTimeMS: 0,
    totalSubscribedTimeMS: 0,
    overAllowedCount: 0,
};
export class ConsumerStateMetricsCollector {
    eventEmitter;
    _metrics = cloneDeep(ZERO_METRICS);
    _consumerStates = {};
    _latestConsumerInfo = {};
    _lastSubscribedUpdateTime = 0;
    _maxTimeToConnectMS;
    _started = false;
    getConnectionReport;
    constructor(eventEmitter, maxTimeToConnectMS = 20000) {
        this.eventEmitter = eventEmitter;
        this._maxTimeToConnectMS = maxTimeToConnectMS;
    }
    start() {
        if (this._started)
            return;
        this._started = true;
        this.resetCollection();
        this._updateConsumerStates(this._latestConsumerInfo);
    }
    stop() {
        if (!this._started)
            return;
        this._started = false;
        Object.values(this._consumerStates).forEach((state) => {
            state.destroy();
        });
        this._consumerStates = {};
    }
    consumerInfoEvent = (infoMap) => {
        this._latestConsumerInfo = infoMap;
        if (!this._started)
            return;
        this._updateTime();
        this._updateConsumerStates(infoMap);
    };
    outputMetrics() {
        if (!this._started)
            return [];
        this._updateTime();
        return [{ name: "video-client", values: this._metrics }];
    }
    resetCollection() {
        this._lastSubscribedUpdateTime = gatherVideoClientDataSource.performance().now();
        this._metrics = cloneDeep(ZERO_METRICS);
    }
    _updateConsumerStates(infoMap) {
        const onDisconnectTimeout = async (playerId, overAllowed, stateTimeSummary) => {
            this._metrics.failToConnectCount++;
            if (!overAllowed) {
                const connectionReport = await this.getConnectionReport?.(playerId);
                eventsManager
                    .addEvent(MetricsEventName.AV_STUCK_CONNECTING, {
                    timeInSeconds: this._maxTimeToConnectMS / 1000,
                    srcId: playerId,
                    connectionState: `${infoMap[playerId]?.state}`,
                })
                    .catch(Logger.error);
                Logger.error("Stuck connecting to video servers", new ErrorContext({
                    srcId: playerId,
                    state: `${infoMap[playerId]?.state}`,
                    ...connectionReport,
                    ...stateTimeSummary,
                }));
                const playerState = infoMap[playerId]?.state;
                if (playerState) {
                    this.eventEmitter.publishEvent(GVCInternalEvent.StuckConnecting, playerId, playerState, true);
                }
            }
        };
        const onRecovery = (playerId) => {
            const playerState = infoMap[playerId]?.state;
            if (playerState) {
                this.eventEmitter.publishEvent(GVCInternalEvent.StuckConnecting, playerId, playerState, false);
            }
        };
        const onOverAllowed = () => {
            this._metrics.overAllowedCount++;
        };
        Object.entries(infoMap).forEach(([playerId, info]) => {
            const prevState = this._consumerStates[playerId];
            const newState = info.state;
            const newOverAllowed = info.overAllowed;
            if (!prevState) {
                this._consumerStates[playerId] = new ConsumerStateWrapper(newState, newOverAllowed, this._maxTimeToConnectMS, (overAllowed, stateTimeSummary) => onDisconnectTimeout(playerId, overAllowed, stateTimeSummary), () => onRecovery(playerId), onOverAllowed);
            }
            else {
                prevState.setState(newState);
                prevState.setOverAllowed(newOverAllowed);
            }
        });
        Object.entries(this._consumerStates).forEach(([playerId, state]) => {
            if (!(playerId in infoMap)) {
                state.destroy();
                delete this._consumerStates[playerId];
            }
        });
    }
    _updateTime() {
        const currentTime = gatherVideoClientDataSource.performance().now();
        const deltaTime = currentTime - this._lastSubscribedUpdateTime;
        const numSubscriptions = Object.keys(this._consumerStates).length;
        this._metrics.totalSubscribedTimeMS += deltaTime * numSubscriptions;
        if (numSubscriptions > 0) {
            this._metrics.totalConversationTimeMS += deltaTime;
        }
        this._lastSubscribedUpdateTime = currentTime;
    }
}
//# sourceMappingURL=ConsumerStateMetricsCollector.js.map